/**
 * 뮤테이션 훅이 상위 계층에 노출하는 에러의 최소 표면.
 *
 * tRPC 내부 표현(shape·data·cause)을 위젯·UI 계층에 흘리지 않기 위한 공용 계약 —
 * features 의 model 훅은 error 를 반드시 이 타입으로 좁혀 반환한다.
 */
export interface MutationError {
  readonly message: string;
}

/** tRPC 응답의 오류 코드(data.code). 응답을 받지 못한 통신 오류는 data 가 없어 null — model 훅이 거부를 가를 때 쓴다. */
export const errorCodeOf = (cause: unknown): string | null => {
  if (!(cause && typeof cause === 'object' && 'data' in cause)) return null;
  const data = cause.data;
  return data && typeof data === 'object' && 'code' in data ? String(data.code) : null;
};

/** 화면 문구에 넣을 원인 — Error 의 message, 비었거나 Error 가 아니면 '알 수 없는 오류'. */
export const describeCause = (cause: unknown): string =>
  cause instanceof Error && cause.message.length > 0 ? cause.message : '알 수 없는 오류';
